import './styles.scss';
import React from 'react';

import { useStateBus } from '~/state/bridge';
import {
  getInterests,
  getCities,
  getTargetingVisible,
} from '~/state/Targeting/selectors';

import CityInput from './CityInput';
import InterestInput from './InterestInput';
import CustomAudiences from './CustomAudiences';
import { useAuthSelector } from '~/theseus/containers/Auth';
import { useAccountQuery } from '~/theseus/hooks/queries';

const Targeting = () => {
  const interests = useStateBus(getInterests);
  const cities = useStateBus(getCities);
  const [accountId] = useAccountQuery();
  const accessToken = useAuthSelector(state => state.context.authToken);
  const isVisible = useStateBus(getTargetingVisible);

  if (!isVisible) {
    return null;
  }

  return (
    <div className="targeting collage collage--enabled">
      <div className="targeting__main-container" style={{ zIndex: 9000 }}>
        <div className="targeting__input-groups">
          <div className="collage__header">
            <h2>Targeting</h2>
            <p>Tailor your ads to target your audience</p>
          </div>
          <CityInput
            cities={cities}
          />
          <InterestInput
            interests={interests}
            accountId={accountId}
          />
          <CustomAudiences
            accountId={accountId}
            accessToken={accessToken}
          />
        </div>
      </div>
    </div>
  );
};

export default Targeting;
